import { ICON__upload } from '@/assets/icons_fa';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_image } from '@/state/ui/_base/LOCAL__ui_set_image';
import { upload_image_single, UTILS__upload } from '@/utils/utils_upload';
import { DTO__file_data } from '@shared/dto/+image/image_asset_base/DTO__file_data';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function IMAGE_COMPARE__image_a__upload() {
  const dispatch = use_dispatch();

  /*
   * STORE
   */

  const { t: t_base_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { toast } = useToast();

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  /*
   * STATE
   */
  const [is_hovered, set_is_hovered] = useState(false);

  /*
   * EVENTS
   */

  function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    upload_image_single(toast, upload_image, t_base_ui);
  }

  async function upload_image(file_data: DTO__file_data) {
    let image = await UTILS__upload.image_to_workspace([file_data], ENUM__image_asset_category.IMAGE, workspace_current._id);
    if (image.is_stub()) return;

    dispatch(LOCAL__ui_set_image({ key: 'grid2d_image_compare__image_a', value: image }));
  }
  /*
   * METHODS
   */

  /*
   * HTML
   */

  return (
    <div
      onMouseEnter={() => set_is_hovered(true)}
      onMouseLeave={() => set_is_hovered(false)}
      className={`flex-center flex-col  size-full
        text-component-item
        border 
        cursor-pointer
        ${is_hovered && 'text-component-item-foreground'}
        ${is_hovered && 'border-2 border-component-item-border'}
        transition-colors rounded`}
      {...{ onClick }}
    >
      <ICON__upload className={`!size-6  mb-1`} />
      <span className="text-xs ">Click to upload</span>
    </div>
  );
}
